import { create } from 'zustand';

import { EFeatureFlagType, IFeatureFlagStore } from './types';

export const featureFlagStoreValues: Readonly<IFeatureFlagStore> = {
  featureFlags: [{
    type: EFeatureFlagType.HELLO_WORLD,
    name: 'Hello World',
    enabled: import.meta.env.VITE_TESTING_INPUT_ENABLED === 'true',
    description: 'Some description',
  }],
};

export const featureFlagStore = create<IFeatureFlagStore>()(() => featureFlagStoreValues);
